import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const query = gql`
query AbsenceReasons($id: Int!) {
  absenceReason(id: $id) {
    id
    message
    teams {
      id
      name
    }
    allTeamsOn
  }
}`;

function getAbsenceReason({ id }) {
  return apollo.client.query({
    query,
    variables: { id: parseInt(id, 10) },
    fetchPolicy: 'network-only',
  }).then((data) => data.data.absenceReason);
}

export default getAbsenceReason;
